export default __webpack_public_path__ + "static/media/element_spec_69.2775434a.jpg";